import React from "react";
import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss"
import Select from "react-select";
import { createGroup, groupsLookup } from "../../../../components/Axios/Axios";
import { Toaster } from "react-hot-toast";
import useCustomToast from "../../../../hooks/useCustomToast";
import AdminPagesProvider from "../../../../providers/AdminPagesProvider";
// import Chart from 'react-apexcharts';
// import 'apexcharts';
function UserGroupForm() {
    const customToast = useCustomToast()
    const [groupName, setGroupName] = React.useState("");
    const [selectedGroupptions, setSelectedGroupOptions] = React.useState<any>([]);
    const [groupOptions, setGroupOptions] = React.useState<any>([])
    const handleMultiSelectGroupChange = (selected: any) => {
        console.log(selected);
        setSelectedGroupOptions(selected);
    };

    const getLookups = async () => {

        try {
            const data = await groupsLookup();
            const formattedData = data.map((item: { model: any; action: any; actionName: any; }) => ({
                value: `${item.model} | ${item.actionName}`,
                label: `${item.model} | ${item.actionName}`,
                model: item.model,
                action: item.action,
                actionName: item.actionName
            }));
            setGroupOptions(formattedData);
            console.log(groupOptions)
        }
        catch (error) {
            console.error("Error adding flight", error);
        }

    }

    React.useEffect(() => {
        getLookups();
    }, []);

    const resetFormState = () => {
        setGroupName("");
        setSelectedGroupOptions([]);
    }


    const onSubmitForm = async (e: any) => {
        e.preventDefault();

        let success = false;
        const selectedPermissions = selectedGroupptions.map((selectedOption: any) => ({
            action: selectedOption.action,
            model: selectedOption.model
        }));

        const data2 = {
            name: groupName,
            perms: selectedPermissions
        };

        console.log(data2, "body1 Payload");

        try {
            await createGroup(data2);
            success = true;
        } catch (error) {
            console.error("Error creating group:", error);
        }

        if (success) {
            customToast("Group Created", "success");
            resetFormState();
        } else {
            customToast("Failed. Group already exists with the same name", "error");
        }
    };


    return (
       <AdminPagesProvider>
        <LayoutProvider>
            <Toaster/>
            <h6 className="dashboard_subheading">Dashboard {">"} Groups Form</h6>
            <section
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <h4 className="dashboard_heading">Groups Form</h4>
            </section>
            <form className="form-wrapper" style={{ marginTop: "2%" }} onSubmit={onSubmitForm}>
                <h2 className="heading3">Add New Group</h2>
                <div >
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" placeholder="Enter Group Name" value={groupName} id="group_name" onChange={e => setGroupName(e.target.value)} />
                </div>
                <div style={{ marginTop: "2%" }}>
                    <label className="form-label">Permissions</label>
                    <Select
                        isMulti
                        options={groupOptions}
                        value={selectedGroupptions}
                        onChange={handleMultiSelectGroupChange}
                        placeholder="Select Permissions"
                        styles={{
                            container: (provided) => ({
                                ...provided,
                                marginBottom: "5%",
                                maxWidth: "100%",
                                fontSize: "1rem",
                                fontWeight: "400",
                                lineHeight: "1.5",
                                height: "40px ",

                                }),
                                clearIndicator: () => ({ display: "none" }), // Hide the clear indicator (X icon)
                            }}
                        />
                    </div>
                    <div className="d-flex justify-content-end" ><button className="button">Save Group</button></div>
                </form>

            </LayoutProvider>
        </AdminPagesProvider>
    );
}

export default UserGroupForm;
